import React, { useState } from "react";
import {
  Box,
  Button,
  ButtonGroup,
  Menu,
  MenuItem,
  Typography,
  LinearProgress,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useAuditoriaUtils } from "../hooks/useAuditoriaUtils";
import { useLiquidaciones } from "../contexts/LiquidacionesContext";
import { CapSentence } from "../../utils/Utils";
import { toast } from "react-toastify";
import { useLiquidarUtils } from "../hooks/useLiquidarUtils";

export default function LiquidacionesActions() {
  const { handleGetExcelLiquidaciones, handleGetResumenAuditoria } =
    useAuditoriaUtils();
  const { handleLiquidarSeleccionados, fetchLiquidaciones } =
    useLiquidarUtils();

  const { updateLiquidaciones } = useLiquidaciones();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleObtenerExcel = async () => {
    try {
      const response = await handleGetExcelLiquidaciones();
      if (!response.error && response.listado) {
        const today = new Date();
        const formattedDate = today.toISOString().split("T")[0];
        const fileName = `liquidacion-${formattedDate}.xlsx`;

        const link = document.createElement("a");
        link.href = response.listado;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("Buscar el Excel en la carpeta Descargas...");
      } else {
        toast.error("No se pudo generar el Excel.");
      }
    } catch {
      toast.error("Error al generar el Excel");
    }
  };

  const opciones = [
    {
      label: "Solo emitir liquidaciones",
      action: () => handleLiquidarSeleccionados("soloEmitir"),
    },
    {
      label: "Reenviar los mails de las liquidaciones",
      action: () => handleLiquidarSeleccionados("soloEnviar"),
    },
    {
      label: "Obtener Excel de la liquidación",
      action: handleObtenerExcel,
    },
  ];

  return (
    <Box display="flex" alignItems="center" gap={2} mb={2}>
      <ButtonGroup variant="contained">
        <Button onClick={() => handleLiquidarSeleccionados("liquidarYEnviar")}>
          Liquidar y enviar mails
        </Button>
        <Button size="small" onClick={handleMenuClick}>
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {opciones.map((op, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              handleMenuClose();
              op.action();
            }}
          >
            {op.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
